import { HOST } from "../../settings/setting";
import { authFecth } from "../../helpers/authFecth";

export const createCheckoutSession = async (payload: {
  product_type: "course" | "background" | "bundle";
  coupon_key?: string;
  discount?: number;
  success_url: string;
  cancel_url: string;
  order_id?: string;
  email?: string;
  first_name?: string;
  middle_name?: string;
  last_name?: string;
}): Promise<{ checkoutUrl: string; sessionId: string }> => {
  return (await authFecth(
    `${HOST}/api/stripe/checkout-session`,
    "post",
    payload,
  )) as { checkoutUrl: string; sessionId: string };
};
